export default "__VITE_ASSET__Bda3XfXa__"